var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-combobox-option-item",class:[{
		selected: _vm.selected,
		focused: _vm.focused
	}],attrs:{"aria-selected":_vm.selected,"tabindex":"1"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onSelect($event)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.onSelect($event)}}},[_c('div',{staticClass:"menu-combobox-option-item-icon-wrapper"},[_c('t-timpex-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected),expression:"selected"}],staticClass:"menu-combobox-option-item-icon",class:[{
				selected: _vm.selected,
				focused: _vm.focused
			}],attrs:{"icon":"tick","type":"bp"}})],1),_c('span',{staticClass:"menu-combobox-option-item-inner",class:[{
			selected: _vm.selected,
			bold: _vm.bold,
			focused: _vm.focused
		}],style:(_vm.itemStyle)},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }